import React, { useState } from 'react';
import './QuestionInput.css';

const QuestionInput = ({ sessionData, onComplete, onBack }) => {
  const [question, setQuestion] = useState(sessionData.userQuestion || '');
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const maxChars = 500;
  const charCount = question.length; // Calculate directly from question

  const handleQuestionChange = (e) => {
    const value = e.target.value;
    if (value.length <= maxChars) {
      setQuestion(value);
    }
  };

  const handleConfirm = () => {
    if (question.trim()) {
      setIsConfirmed(true);
    }
  };

  const handleContinue = () => {
    if (question.trim() && isConfirmed && !isProcessing) {
      setIsProcessing(true);
      onComplete(question.trim());
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      if (!isConfirmed && question.trim()) {
        handleConfirm();
      } else if (isConfirmed) {
        handleContinue();
      }
    }
  };

  return (
    <div className="oracle-step question-input-step">
      <h2>O que você quer desbloquear?</h2>
      <p>
        Formule uma pergunta ou descreva uma situação sobre a qual você gostaria de receber orientação do Oráculo dos 12 Raios.
        Seja específico e honesto - o universo responde à autenticidade.
      </p>

      {/* Tips section moved to top for better UX flow */}
      <div className="question-tips">
        <h4>✨ Dicas para uma consulta mais eficaz</h4>
        <div className="floating-tips">
          <div className="thought-cloud tip-1">
            <div className="cloud-content">Seja específico sobre a situação</div>
            <div className="cloud-tail"></div>
          </div>
          
          <div className="thought-cloud tip-2">
            <div className="cloud-content">Foque no que você pode controlar</div>
            <div className="cloud-tail"></div>
          </div>
          
          <div className="thought-cloud tip-3">
            <div className="cloud-content">Evite perguntas de sim/não simples</div>
            <div className="cloud-tail"></div>
          </div>
          
          <div className="thought-cloud tip-4">
            <div className="cloud-content">Pergunte sobre orientações, não previsões</div>
            <div className="cloud-tail"></div>
          </div>
          
          <div className="thought-cloud tip-5">
            <div className="cloud-content">Deixe sua intuição fluir livremente</div>
            <div className="cloud-tail"></div>
          </div>
        </div>
      </div>

      <div className="question-container">
        <div className="input-wrapper">
          <textarea
            value={question}
            onChange={handleQuestionChange}
            onKeyPress={handleKeyPress}
            placeholder="Escreva sua pergunta ou situação aqui...&#10;&#10;Exemplo: 'Como posso superar o medo de tomar decisões importantes na minha carreira?'"
            className="question-textarea"
            rows={6}
          />
          
          <div className="input-footer">
            <div className="char-counter">
              <span className={charCount > maxChars * 0.8 ? 'warning' : ''}>
                {charCount}/{maxChars}
              </span>
            </div>
          </div>
        </div>

        {/* Show confirm button when there's text but not confirmed yet */}
        {question.trim() && !isConfirmed && (
          <div className="confirm-button-container">
            <button onClick={handleConfirm} className="confirm-btn">
              Confirmar Pergunta ✨
            </button>
          </div>
        )}

        {/* Show golden confirmation box when confirmed */}
        {isConfirmed && (
          <div className="question-confirmation">
            <div className="confirmation-icon">✨</div>
            <p>Pergunta capturada pelo Oráculo dos 12 Raios</p>
            <small>Esta pergunta guiará toda sua consulta mística</small>
          </div>
        )}
      </div>

      <div className="step-navigation">        
        <button 
          onClick={handleContinue}
          className="continue-btn primary-cta"
          disabled={!isConfirmed || isProcessing}
          title={!isConfirmed ? 'Confirme sua pergunta primeiro' : (isProcessing ? 'Processando...' : 'Ctrl+Enter para continuar')}
          style={{ margin: '0 auto' }}
        >
          {isProcessing ? 'Processando...' : 'Continuar →'}
        </button>
      </div>
    </div>
  );
};

export default QuestionInput;